<template>
  <div class="contact" :style="'height:' + (fullHeight-100) + 'px;'">
    <img src="../../assets/imgs/contact/header.png" alt="" />
    <img src="../../assets/imgs/contact/main.png" alt="" />
  </div>
</template>

<script>
export default {
  data(){
    return {
      fullHeight: document.documentElement.clientHeight
    }
  },
  
  watch: {
    fullHeight (val) {//监控浏览器高度变化
      if(!this.timer) {
        this.fullHeight = val
        this.timer = true
        let that = this
        setTimeout(function (){
          that.timer = false
        },400)
      }
      
    }
  },
  mounted () {
    this.get_bodyHeight()
  },
  methods :{
    get_bodyHeight () {//动态获取浏览器高度
      const that = this
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight
          that.fullHeight = window.fullHeight
        })()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.contact{
  width: 100%;
  height: 100%;
  background-color: white;
  img{
    width: 100%;
    height: auto;
  }
}
</style>
